import * as tslib_1 from "tslib";
import { ESRI } from '../esri-loader-util';
import { MapService } from './map.service';
import * as i0 from "@angular/core";
import * as i1 from "./map.service";
var ScalebarService = /** @class */ (function () {
    function ScalebarService(mapService) {
        this.mapService = mapService;
    }
    Object.defineProperty(ScalebarService.prototype, "Scalebar", {
        get: function () {
            return this.scalebar;
        },
        enumerable: true,
        configurable: true
    });
    ScalebarService.prototype.showScalebar = function (show, options) {
        if (show === void 0) { show = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.scaleBarConstructor == null)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, ESRI.ScaleBarWidget];
                    case 1:
                        _a.scaleBarConstructor = _b.sent();
                        _b.label = 2;
                    case 2:
                        if (this.scalebar == null) {
                            this.scalebar = new this.scaleBarConstructor({
                                view: this.mapService.mcMapView,
                                unit: options.unit,
                                style: options.style
                            });
                            this.mapService.mcMapView.ui.add(this.scalebar, { position: options.position });
                        }
                        this.scalebar.visible = show;
                        return [2 /*return*/];
                }
            });
        });
    };
    ScalebarService.prototype.removeScalebar = function () {
        if (this.scalebar) {
            this.mapService.mcMapView.ui.remove(this.scalebar);
            this.scalebar = null;
        }
    };
    ScalebarService.ngInjectableDef = i0.defineInjectable({ factory: function ScalebarService_Factory() { return new ScalebarService(i0.inject(i1.MapService)); }, token: ScalebarService, providedIn: "root" });
    return ScalebarService;
}());
export { ScalebarService };
